export enum BulkWellStatusChangeStatus {
    NotSubmitted = 'Not Submitted',
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected'
}

export interface BulkWellStatusChangeDetails {
    detailsId?: string,
    requestId: string,
    apiNumber: string,
    wellName?: string,
    wellNumber?: string,
    fromWellStatus: string,
    toDisposition?: string,
    toStatusReason?: string,
    toTypeDescription?: string,
    toStatusDate?: Date,
    mapSymbol?: string,
    dateUploaded?: Date,
    notes?: string
}

export interface BulkWellStatusChangeFile {
    id?: string;
    requestId?: string;
    blobUri: string;
    fileName: string;
    extension: string;
    type: string;
}

export interface BulkWellStatusChange {
    requestId: string,
    status: BulkWellStatusChangeStatus,
    dateRequested: Date,
    dateApproved?: Date,
    dateRejected?: Date,
    requestedById: string,
    requestedByName: string,
    approvedById?: string,
    approvedByName?: string,
    rejectedById?: string,
    rejectedByName?: string,
    reasonForRequest: string,
    bulkWellStatusChangeDetails: BulkWellStatusChangeDetails[],
    bulkWellStatusChangeFiles: BulkWellStatusChangeFile[]
}

export interface BulkWellStatusChangeRequest {
    apiNumber: string,
    wellName: string,
    wellNumber: string,
    fromWellStatus: string,
    toDisposition: string,
    toStatusReason: string,
    toTypeDescription: string,
    mapSymbol: string,
    toStatusDate: Date,
    dateUploaded: Date,
    notes: string
}

export interface BulkWellStatusChangeSearchSpec {
    changeId: string;
    status: BulkWellStatusChangeStatus[];
}

export interface BulkWellStatusChangeSearchResult {
    requestId: string,
    dateRequested: Date,
    requestedById: string,
    requestedByName: string,
    approvedById: string,
    approvedByName: string,
    dateApproved: Date,
    rejectedById: string,
    rejectedByName: string,
    dateRejected: Date,
    apiNumber: string,
    wellName: string,
    wellNumber: string,
    fromWellStatus: string,
    fromStatusDate: Date,
    toDisposition: string,
    toStatusReason: string,
    toTypeDescription: string,
    toStatusDate: Date,
    mapSymbol: string,
    dateUploaded: Date,
    notes: string
}

